module.exports = __webpack_public_path__ + "img/25_67.3260aae9.png";